import { isUnknownGame } from 'src/types/domain/Game'
import { isAuthenticatedPlayer } from 'src/types/domain/Player'
import { useGetCurrentGame } from 'src/store/game'
import { useGetCurrentPlayer } from 'src/store/player'
import { ToolbarInfo } from './ToolbarInfo'

export function ToolbarInfoContainer() {
  const player = useGetCurrentPlayer()
  const game = useGetCurrentGame()

  if (isUnknownGame(game) || !isAuthenticatedPlayer(player)) {
    return null
  }

  return <ToolbarInfo game={game} />
}
